import { usePrivileges } from '../../utils';
import pagePrivilegesNeeded from '../../utils/pagePrivilegesNeeded';

function CasesPageSubmenu({ renderItems, translate }) {
  const { hasAnyPrivilege } = usePrivileges();

  return renderItems([
    { label: translate('list'), link: 'list' },
    { label: translate('stats'), link: 'stats', disabled: !hasAnyPrivilege(pagePrivilegesNeeded.stats) },
  ]);
}

export default CasesPageSubmenu;
